import React from "react";
import { PostBannerLayout } from "../entities/post-banner-layout";
import { PageRenderer } from "../entities/page-renderer";
export var defaultEntityLayouts = {
  Post: PostBannerLayout,
  Page: PageRenderer
};
export var EntityLayoutsContext = React.createContext(defaultEntityLayouts);
export var EntityLayoutsProvider = EntityLayoutsContext.Provider;